// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Time20 from './Time20.tsx';
import Time24 from './Time24.tsx';
import Time40 from './Time40.tsx';
import Time48 from './Time48.tsx';

type TimeProps = {
    variation: '20' | '24' | '40' | '48';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Time20,
    Time24,
    Time40,
    Time48,
};

const Time: FC<TimeProps> = ({ variation, ...props }) => {
    const variationKey = `Time${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Time" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Time;
